import { useState, useEffect } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import './Checkout.css'

function Checkout() {
  const { orderId } = useParams()
  const { token } = useAuth()
  const navigate = useNavigate()
  const [order, setOrder] = useState(null)
  const [loading, setLoading] = useState(true)
  const [processing, setProcessing] = useState(false)

  useEffect(() => {
    const fetchOrder = async () => {
      try {
        const response = await fetch(`${import.meta.env.VITE_API_URL}/api/orders/${orderId}`, {
          headers: { Authorization: `Bearer ${token}` }
        })
        if (!response.ok) throw new Error('Order not found')
        const data = await response.json()
        setOrder(data.data)
      } catch (error) {
        console.error('❌ Error loading order:', error)
        alert('Bestelling niet gevonden')
        navigate('/shop')
      } finally {
        setLoading(false)
      }
    }

    if (orderId && token) fetchOrder()
  }, [orderId, token, navigate])

  const handleMolliePayment = async () => {
    setProcessing(true)
    try {
      const response = await fetch(
        `${import.meta.env.VITE_API_URL}/api/orders/create-mollie-session`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
          },
          body: JSON.stringify({
            orderId: orderId,
            items: order.attributes.items,
            total_price: order.attributes.orderTotal,
            customer_email: order.attributes.customer_email,
            customer_name: order.attributes.customer_name
          })
        }
      )

      if (!response.ok) {
        const error = await response.json()
        console.error('❌ Mollie error:', error)
        throw new Error('Payment initiation failed')
      }

      const mollieData = await response.json()
      console.log('✅ Mollie session created:', mollieData)

      // Redirect to Mollie checkout
      if (mollieData.checkoutUrl) {
        window.location.href = mollieData.checkoutUrl
      }
    } catch (error) {
      console.error('❌ Payment error:', error)
      alert('Kan betaling niet starten. Probeer het later opnieuw.')
      setProcessing(false)
    }
  }

  if (loading) return <div className="checkout"><p>Bestelling laden...</p></div>
  if (!order) return null

  const items = JSON.parse(order.attributes.items)

  return (
    <div className="checkout">
      <div className="checkout-container">
        <h1>Afrekenen</h1>

        <div className="order-summary">
          <h2>Bestellingsgegevens</h2>
          <p><strong>Bestelling ID:</strong> #{order.id}</p>
          <p><strong>Klant:</strong> {order.attributes.customer_name}</p>
          <p><strong>E-mail:</strong> {order.attributes.customer_email}</p>

          <h3>Georderde artikelen</h3>
          <table className="items-table">
            <thead>
              <tr>
                <th>Product</th>
                <th>Prijs</th>
              </tr>
            </thead>
            <tbody>
              {items.map((item, index) => (
                <tr key={index}>
                  <td>{item.name}</td>
                  <td>€{item.price?.toFixed(2)}</td>
                </tr>
              ))}
            </tbody>
          </table>

          <div className="total">
            <strong>Totaal:</strong>
            <span>€{(order.attributes.orderTotal / 100)?.toFixed(2)}</span>
          </div>
        </div>

        <button
          className="btn-mollie-payment"
          onClick={handleMolliePayment}
          disabled={processing}
        >
          {processing ? 'Betaling wordt verwerkt...' : '💳 Betalen met Mollie'}
        </button>

        <button
          className="btn-back"
          onClick={() => navigate('/shop')}
          disabled={processing}
        >
          Terug naar winkel
        </button>
      </div>
    </div>
  )
}

export default Checkout
